import { MESSAGE_SOURCE } from './constants';
import type { MessageInterface } from './types/MessageInterface';

export const createMessage = <T = Record<string, unknown>>(
  payload: T,
): MessageInterface<T> => ({
  source: MESSAGE_SOURCE,
  payload,
});
